<template>
  <success title="提交成功" :show-bottom-close-btn="false">
    <p class="result-info">{{statusTxt}}</p>
  </success>
</template>

<script>
import Success from '../components/Success'
export default {
  components: {
    Success
  },
  data () {
    return {
      status: ''
    }
  },
  created () {
    this.status = this.$route.params.status
  },
  computed: {
    statusTxt () {
      let status = this.status
      let statusTxt = ''
      if (status === 'pending_review') {
        statusTxt = '优惠券已超出允许范围，待审核通过后继续办理，请留意审核结果通知'
      } else { // 无需审核
        statusTxt = '请引导客户完成支付'
      }
      return statusTxt
    }
  }
}
</script>

<style lang="less">
</style>
